import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { apiPost } from "api/callApi";
import AssignUserDropdown from "components/AssignUserDropdown";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { showAlert } from "utils/helper";
import AssignMultipleUserInOccupant from "components/AssignMultipleUserInOccupant";

function AssignUser(props) {
  const { openAssignModalView, setOpenAssignModalView, roleId } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );

  const handleChangeCompany = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleAssignUser = async () => {
    try {
      const result = await apiPost(`/v1/occupant/contactinformation`, {
        ...data,
        projectId: currentProject.id,
        occupantId: currentOccupant.id,
        roleId: roleId,
      });
      showAlert({ title: "Success", text: result?.message, icon: "success" });
      setOpenAssignModalView(false);
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
      console.log("Error", error);
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenAssignModalView(false);
    setData({});
  };

  const AddCompanyModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Select User"}>
            <AssignUserDropdown
              name="userId"
              projectId={projectId}
              type={type}
              onChange={handleChangeCompany}
              roleId={roleId}
            />
            <AssignMultipleUserInOccupant width="20%" />
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelCompanyModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Assign"}
            isLoading={loading}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
            onClick={handleAssignUser}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openAssignModalView && (
        <BulkActionView
          title={"Assign User"}
          openModal={openAssignModalView}
          renderBodyConditionally={AddCompanyModalData}
          handleCloseModal={() => {
            setOpenAssignModalView(false);
            setData("");
          }}
        />
      )}
    </>
  );
}

export default AssignUser;
